import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Terms from "../views/Terms.vue";
import Policy from "../views/Policy.vue";
import UserTable from "../views/admin/users/Tables.vue";
import UserCreate from "../views/admin/users/Create.vue";
import ModelsTable from "../views/admin/models/Tables.vue";
import ModelsCreate from "../views/admin/models/Create.vue";
import PaymentTable from "../views/admin/payments/Tables.vue";
import ProductionTable from "../views/admin/production/Tables.vue";
import ProductionCreate from "../views/admin/production/Create.vue";
import OperationsTable from "../views/admin/operations/Tables.vue";

import ReportTable from "../views/admin/reports/Tables.vue";
import SuppliesTable from "../views/admin/supplies/Tables.vue";
import SuppliesCreate from "../views/admin/supplies/Create.vue";
import CatalogOrder from "../views/admin/supplies/CatalogOrder.vue";
import PromotionsTable from "../views/admin/promotions/Tables.vue";
import PromotionsCreate from "../views/admin/promotions/Create.vue";
import PurchasesTable from "../views/admin/purchases/Tables.vue";
import PurchasesCreate from "../views/admin/purchases/Create.vue";
import NominaTable from "../views/admin/nomina/Tables.vue";
import NominaPaymentsTable from "../views/admin/nomina/Payments.vue";
import NominaProductionsTable from "../views/admin/nomina/Production.vue";
import Login from "../views/auth/Login.vue";
import Register from "../views/auth/Register.vue";
import RemissionsTable from "../views/admin/remissions/Table.vue";
import RemissionsCreate from "../views/admin/remissions/Create.vue";
import RemissionsPickingPacking from "../views/admin/remissions/PickingPacking.vue";
import CashSessions from "../views/admin/cash/CashSessions.vue";
import Settings from "../views/admin/settings/Settings.vue";
import SettingsCategorias from "../views/admin/settings/categorias/Tables.vue";
import SettingsColecciones from "../views/admin/settings/colecciones/Tables.vue";
import SettingsBodegas from "../views/admin/settings/bodegas/Tables.vue";
import SettingsColores from "../views/admin/settings/colores/Tables.vue";
import SettingsTallas from "../views/admin/settings/tallas/Tables.vue";
import SettingsOficios from "../views/admin/settings/oficios/Tables.vue";
import SettingsDisenos from "../views/admin/settings/disenos/Tables.vue";
import UserProfile from "../views/examplesApi/UserProfile/EditUserProfile.vue";
import ForgotPassword from "../views/auth/ForgotPassword.vue";
import ResetPassword from "../views/auth/ResetPassword.vue";
import auth from "../middleware/auth";
import guest from "../middleware/guest";
import operator from "../middleware/operator";
import success from "../views/success.vue";
import fail from "../views/fail.vue";
import OperadorDashboard from "../views/operador/Dashboard.vue";
import OperadorPos from "../views/operador/Pos.vue";
import OperadorPosTicket from "../views/operador/PosTicket.vue";
import OperadorSales from "../views/operador/Sales.vue";
import OperadorSalesCreate from "../views/operador/SalesCreate.vue";
import OperadorPickingPacking from "../views/operador/PickingPacking.vue";
import PublicCatalog from "../views/catalog/Catalog.vue";
import PosView from "../views/admin/pos/Pos.vue";
import PosTicket from "../views/admin/pos/PosTicket.vue";

const routes = [
  {
    path: "/catalogo/:token",
    name: "Public Catalog",
    component: PublicCatalog,
    meta: { layout: "landing" },
  },
  // Detalle de producto: mismo componente que el catálogo para conservar carrito y productos cargados
  {
    path: "/catalogo/:token/producto/:productId",
    name: "Public Catalog Product",
    component: PublicCatalog,
    meta: { layout: "landing" },
  },
  {
    path: "/",
    name: "/",
    redirect: "/dashboard-default",
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      middleware: guest,
    },
  },
  {
    path: "/dashboard-default",
    name: "Dashboard",
    component: Dashboard,
    meta: {
      middleware: auth,
      routeName: "Inicio",
    },
  },
  {
    path: "/pos",
    name: "POS",
    component: PosView,
    meta: {
      middleware: auth,
      routeName: "POS",
    },
  },
  {
    path: "/cash-sessions",
    name: "Cash Sessions",
    component: CashSessions,
    meta: {
      middleware: auth,
      routeName: "Cierres de caja",
    },
  },
  {
    path: "/pos-ticket",
    name: "POS Ticket",
    component: PosTicket,
    meta: {
      middleware: auth,
      routeName: "Ticket POS",
    },
  },
  {
    path: "/users",
    name: "Users",
    routeName: "Usuarios",
    component: UserTable,
    meta: {
      middleware: auth,
      routeName: "Usuarios",
    },
  },
  {
    path: "/users/create",
    name: "User Create",
    routeName: "Crear Usuarios",
    component: UserCreate,
    meta: {
      middleware: auth,
      routeName: "Crear Usuario",
    },
  },
  {
    path: "/models",
    name: "Models",
    routeName: "Modelos",
    component: ModelsTable,
    meta: {
      middleware: auth,
      routeName: "Modelos",
    },
  },
  {
    path: "/models/create",
    name: "Models Create",
    routeName: "Crear Modelo",
    component: ModelsCreate,
    meta: {
      middleware: auth,
      routeName: "Crear Modelo",
    },
  },
  {
    path: "/nomina",
    name: "Nomina",
    routeName: "Nomina",
    component: NominaTable,
    meta: {
      middleware: auth,
      routeName: "Nomina",
    },
  },
  {
    path: "/nomina-payments",
    name: "Nomina Payments",
    routeName: "Nomina-payments",
    component: NominaPaymentsTable,
    props: true,
    meta: {
      middleware: auth,
      routeName: "Pagos Nomina",
    },
  },
  {
    path: "/nomina-productions",
    name: "Nomina Productions",
    routeName: "Trabajos realizados",
    component: NominaProductionsTable,
    props: true,
    meta: {
      middleware: auth,
      routeName: "Trabajos realizados",
    },
  },
  {
    path: "/production",
    name: "Production",
    routeName: "Producción",
    component: ProductionTable,
    meta: {
      middleware: auth,
      routeName: "Producción",
    },
  },

  {
    path: "/operations",
    name: "Operations",
    routeName: "Operaciones",
    component: OperationsTable,
    meta: {
      middleware: auth,
      routeName: "Operaciones",
    },
  },

  {
    path: "/production/create",
    name: "Production Create",
    routeName: "Crear Producción",
    component: ProductionCreate,
    meta: {
      middleware: auth,
      routeName: "Crear Producción",
    },
  },
  {
    path: "/inventory",
    name: "Inventory",
    routeName: "Inventario",
    component: SuppliesTable,
    meta: {
      middleware: auth,
      routeName: "Inventario",
    },
  },
  {
    path: "/promotions",
    name: "Promotions",
    routeName: "Promociones",
    component: PromotionsTable,
    meta: {
      middleware: auth,
      routeName: "Promociones",
    },
  },
  {
    path: "/promotions/create",
    name: "Promotions Create",
    routeName: "Agregar Promoción",
    component: PromotionsCreate,
    meta: {
      middleware: auth,
      routeName: "Agregar Promoción",
    },
  },
  {
    path: "/promotions/edit/:id",
    name: "Promotions Edit",
    routeName: "Editar Promoción",
    component: PromotionsCreate,
    meta: {
      middleware: auth,
      routeName: "Editar Promoción",
    },
  },
  {
    path: "/inventory/catalog-order",
    name: "Catalog Order",
    routeName: "Orden del catálogo",
    component: CatalogOrder,
    meta: {
      middleware: auth,
      routeName: "Orden del catálogo",
    },
  },
  {
    path: "/inventory/create",
    name: "Inventory Create",
    routeName: "Crear Inventario",
    component: SuppliesCreate,
    meta: {
      middleware: auth,
      routeName: "Crear Inventario",
    },
  },
  {
    path: "/inventory/edit/:id",
    name: "Inventory Edit",
    routeName: "Editar Inventario",
    component: SuppliesCreate,
    meta: {
      middleware: auth,
      routeName: "Editar Inventario",
    },
  },
  {
    path: "/purchases",
    name: "Purchases",
    routeName: "Compras",
    component: PurchasesTable,
    meta: {
      middleware: auth,
      routeName: "Compras",
    },
  },
  {
    path: "/reports",
    name: "Reports",
    routeName: "Reportes",
    component: ReportTable,
    meta: {
      middleware: auth,
      routeName: "Reportes",
    },
  },
  {
    path: "/purchases/create",
    name: "Purchases Create",
    routeName: "Crear Compra",
    component: PurchasesCreate,
    meta: {
      middleware: auth,
      routeName: "Crear Compras",
    },
  },
  {
    path: "/settings",
    name: "Settings",
    routeName: "Configuración",
    component: Settings,
    meta: {
      middleware: auth,
      routeName: "Configuración General",
    },
  },
  {
    path: "/settings/general",
    name: "SettingsGeneral",
    component: Settings,
    meta: {
      middleware: auth,
      routeName: "Configuración General",
    },
  },
  {
    path: "/settings/bodegas",
    name: "SettingsBodegas",
    component: SettingsBodegas,
    meta: {
      middleware: auth,
      routeName: "Bodegas",
    },
  },
  {
    path: "/settings/categorias",
    name: "SettingsCategorias",
    component: SettingsCategorias,
    meta: {
      middleware: auth,
      routeName: "Categorías",
    },
  },
  {
    path: "/settings/colecciones",
    name: "SettingsColecciones",
    component: SettingsColecciones,
    meta: {
      middleware: auth,
      routeName: "Referencias",
    },
  },
  {
    path: "/settings/colores",
    name: "SettingsColores",
    component: SettingsColores,
    meta: {
      middleware: auth,
      routeName: "Colores",
    },
  },
  {
    path: "/settings/tallas",
    name: "SettingsTallas",
    component: SettingsTallas,
    meta: {
      middleware: auth,
      routeName: "Tallas",
    },
  },
  {
    path: "/settings/oficios",
    name: "SettingsOficios",
    component: SettingsOficios,
    meta: {
      middleware: auth,
      routeName: "Oficios",
    },
  },
  {
    path: "/settings/disenos",
    name: "SettingsDisenos",
    component: SettingsDisenos,
    meta: {
      middleware: auth,
      routeName: "Diseños",
    },
  },
  {
    path: "/user-profile",
    name: "User Profile",
    routeName: "Perfil",
    component: UserProfile,
    meta: {
      middleware: auth,
      routeName: "Perfil",
    },
  },
  {
    path: "/register",
    name: "Register",
    routeName: "Registro",
    component: Register,
    meta: {
      middleware: guest,
    },
  },
  {
    path: "/remissions",
    name: "Remissions",
    routeName: "Remisiones",
    component: RemissionsTable,
    meta: {
      middleware: auth,
      routeName: "Remisiones",
    },
  },
  {
    path: "/remissions/create",
    name: "Remissions Create",
    routeName: "Crear Remision",
    component: RemissionsCreate,
    meta: {
      middleware: auth,
      routeName: "Crear Remision",
    },
  },
  {
    path: "/remissions/picking-packing",
    name: "Remissions PickingPacking",
    routeName: "Picking / Packing",
    component: RemissionsPickingPacking,
    meta: {
      middleware: auth,
      routeName: "Picking / Packing",
    },
  },
  {
    path: "/password/forgot",
    name: "Forgot Password",
    routeName: "Olvido clave",
    component: ForgotPassword,
    meta: {
      middleware: guest,
    },
  },
  {
    path: "/password/reset",
    name: "Reset Password",
    routeName: "Cambiar clave",
    component: ResetPassword,
    meta: {
      middleware: guest,
    },
  },
  {
    path: "/payment",
    name: "Payment",
    routeName: "Payment",
    component: PaymentTable,
    meta: {
      middleware: auth,
      routeName: "Pagos",
    },
  },
  {
    path: "/terms",
    name: "Terms",
    routeName: "Terminos",
    component: Terms,
  },
  {
    path: "/policy",
    name: "Policy",
    routeName: "Politicas",
    component: Policy,
  },
  {
    path: "/success",
    name: "Success",
    routeName: "Exito",
    component: success,
  },
  {
    path: "/fail",
    name: "Fail",
    routeName: "Fallo",
    component: fail,
  },
  // Rutas para operador
  {
    path: "/operador/dashboard",
    name: "Operador Dashboard",
    routeName: "Dashboard Operador",
    component: OperadorDashboard,
    meta: {
      middleware: [auth, operator],
      routeName: "Dashboard",
    },
  },
  {
    path: "/operador/pos",
    name: "Operador POS",
    routeName: "POS",
    component: OperadorPos,
    meta: {
      middleware: [auth, operator],
      routeName: "POS",
    },
  },
  {
    path: "/operador/pos-ticket",
    name: "Operador POS Ticket",
    routeName: "Ticket POS",
    component: OperadorPosTicket,
    meta: {
      middleware: [auth, operator],
      routeName: "Ticket POS",
    },
  },
  {
    path: "/operador/ventas",
    name: "Operador Sales",
    routeName: "Ventas / Ingresos",
    component: OperadorSales,
    meta: {
      middleware: [auth, operator],
      routeName: "Ventas / Ingresos",
    },
  },
  {
    path: "/operador/ventas/create",
    name: "Operador Sales Create",
    routeName: "Crear Remision",
    component: OperadorSalesCreate,
    meta: {
      middleware: [auth, operator],
      routeName: "Crear Remision",
    },
  },
  {
    path: "/operador/ventas/picking-packing",
    name: "Operador PickingPacking",
    routeName: "Picking / Packing",
    component: OperadorPickingPacking,
    meta: {
      middleware: [auth, operator],
      routeName: "Picking / Packing",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

// Creates a nextMiddleware() function which not only
// runs the default next() callback but also triggers
// the subsequent Middleware function.
function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];
  // If no subsequent Middleware exists,
  // the default next() callback is returned.
  if (!subsequentMiddleware) return context.next;

  return (...parameters) => {
    // Run the default Vue Router next() callback first.
    context.next(...parameters);
    // Then run the subsequent Middleware with a new
    // nextMiddleware() callback.
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

router.beforeEach((to, from, next) => {
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware];
    const context = { from, next, to, router };
    const nextMiddleware = nextFactory(context, middleware, 1);

    return middleware[0]({ ...context, next: nextMiddleware });
  }

  return next();
});

export default router;
